<template lang="pug">
section.always-on
  .blocks.two-cols
    .block
      h3 Kontakt
      .block-content.mobile-flex
        div
          div Dawid Radziemski
          div Rakowiecka 70
          div 50-422 Wrocław
          div tel. 603 135 505
          div e-mail:&nbsp;
            a(href="mailto:devilauto@wp.pl") devilauto@wp.pl
        div
          div
            strong Godziny otwarcia:
          div poniedziałek-piatek 8-17
          div sobota 9-16

        div.fl-100
          iframe(src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4675.868549323862!2d17.067534636823456!3d51.094878413995964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc2907d63c05f%3A0xaf69885f1834fc54!2sDevil%20Auto!5e0!3m2!1sen!2spl!4v1622514046576!5m2!1sen!2spl" width="382" height="287" style="border:0; margin-top: 20px; max-width: 100%;" allowfullscreen="" loading="lazy")


    .block.form-block
        h3 Zapytanie ofertowe
        .block-content(v-if="!response.present")
           form.contact-form(@submit.prevent="formSubmit")
            label(:class="{invalid: v$.email.$error}") E-mail:
             .tooltip.email Niepoprawny E-mail
             input(type="text" v-model="email")
            label(:class="{invalid: v$.name.$error}") Imie:
             .tooltip Wprowadź swoje imie
             input(type="text" v-model="name")
            label(:class="{invalid: v$.brand.$error}") Marka:
              .tooltip Wprowadź markę samochodu
              input(type="text" v-model="brand")

            label(:class="{invalid: v$.model.$error}") Model:
              .tooltip Wprowadź model samochodu
              input(type="text" v-model="model")

            label(:class="{invalid: v$.year.$error}") Rok produkcji:
              .tooltip Wprowadź rok produkcji
              input(type="text" v-model="year")

            label(:class="{invalid: v$.volume.$error}") Pojemność silnika:
              .tooltip Wprowadź pojemność silnika
              input(type="text" v-model="volume")

            label(:class="{invalid: v$.power.$error}") Moc silnika w KW/PS:
              .tooltip Wprowadź moc silnika
              input(type="text" v-model="power")

            label.ta(:class="{invalid: v$.question.$error}") Treść zapytania:
              .tooltip.ta Wpisz swoję zapytanie
              textarea(type="text" v-model="question" rows="3")

            button(type="submit") Wyślij
        .block-content(v-else)
          .response(:class="'status-' + response.status")
            .message {{response.message}}
            .resend
              .btn(v-if="response.status !== '1'" @click.prevent="response = {present: false, status: null, message: null}") Spróbuj ponownie.
</template>

<script>
import { email, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import axios from 'axios';

export default {
  name: "Contacts",
  setup: () => ({
    v$: useVuelidate()
  }),
  data: () => ({
    brand: '',
    model: '',
    year: '',
    volume: '',
    power: '',
    question: '',
    email: '',
    name: '',
    response: {
      present: false,
      status: null,
      message: null
    }
  }),
  validations() {
    return {
      brand: { required },
      model: { required },
      year: { required },
      volume: { required },
      power: { required },
      question: { required },
      name: { required },
      email: { required, email }
    }
  },
  methods: {
    formSubmit() {
      if (this.v$.$invalid) {
        this.v$.$touch()
      } else {
        const msg = [
        this.name,
        this.brand,
        this.model,
        this.year,
        this.volume,
        this.power,
        this.question,
        ]
        this.response = {
          present: false,
          status: null,
          message: null
        }
        axios.post('/contacts.php', {mail: this.email, dcon: msg})
        .then((r) => {
          this.response = {
            present: true,
            status: r.data.status,
            message: r.data.message
          }
        })
        .catch((e) => {
          console.log(e)
          this.response = {
            present: true,
            status: 0,
            message: "Coś poszło nie tak. Wiadomość nie została odesłana."
          }
        })
        .finally(() => {
          const nav = document.getElementsByTagName('nav')[0]
          const yos = nav.offsetTop
          window.scrollTo({top: yos, behavior: 'smooth'})
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.resend {
  width: 100%;
  text-align: center;
  .btn {
    display: inline-block;
    background: #F4BD43;
    color: #000;
    padding: 5px 8px;
    margin-top: 20px;
    cursor: pointer;
  }
}
</style>
